import React from 'react';
import { MailIcon, SettingsIcon } from 'lucide-react';
import { AccordionItem } from './Accordion';
import { OBJECTIONS } from '../data/content';
export function Objections() {
  return <section className="px-5 py-8" data-id="element-121">
      <div className="mx-auto max-w-xl" data-id="element-122">
        <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-123">
          Frequently Asked Questions
        </h2>

        <div className="mt-6 space-y-3" data-id="element-124">
          {OBJECTIONS.map(o => <AccordionItem key={o.q} emoji="❓" title={o.q} data-id="element-125">
              <p className="text-sm leading-relaxed text-white/90" data-id="element-126">{o.a}</p>
            </AccordionItem>)}
        </div>

        {/* Support */}
        <div className="mt-8 flex flex-col items-center gap-2 rounded-2xl border border-white/20 bg-[#101b2d]/95 p-6 text-center shadow-lg shadow-black/20" data-id="element-127">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--pb-lime)]/15 text-[var(--pb-lime)]" data-id="element-128">
            <SettingsIcon size={26} data-id="element-129" />
          </div>
          <p className="text-sm font-600 text-white/80" data-id="element-130">Support</p>
          <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-base font-700 text-[var(--pb-lime)] hover:underline" data-id="element-131">
            <MailIcon size={16} data-id="element-132" />
            EbookDreamShop@gmail.com
          </a>
        </div>
      </div>
    </section>;
}